import { render, staticRenderFns } from "./mapBlackList.vue?vue&type=template&id=323e3cfe&scoped=true"
import script from "./mapBlackList.vue?vue&type=script&lang=js"
export * from "./mapBlackList.vue?vue&type=script&lang=js"
import style0 from "./mapBlackList.vue?vue&type=style&index=0&id=323e3cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e3cfe",
  null
  
)

export default component.exports